import { ReactElement, useEffect, useState } from 'react'
import classes from './PrescriptionDashboard.module.scss'
import Prescription from './Prescription'
import Record from '../Record/Record'
import {
  Avatar,
  DeserveModal,
  LoadingFit,
  SecondaryHeader,
  SecondaryLayout,
  TabGroup,
} from '../../share/Components'
import { Button } from '../../share/Elements'
import { GenderEnum } from '../../enums/GenderEnum'
import {
  DeserveDataModalInterface,
  DeserveModalInterface,
} from '../../Interfaces/DeserveModalInterface'
import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { ReducerType } from '../../storeManager/ReducerType'
import { PrescriptionViewModel } from '../../models/ViewModels/PrescriptionViewModel'
import useFetch from '../../_services/fetch'
import { RaytebRequests } from '../../_services'
import { LoginInterface } from '../../Interfaces/LoginInterface'
import { ErrorTypeEnum } from '../../_services/ResponseErrorType'
import { toast } from 'react-toastify'
import { TabInterface } from '../../Interfaces/TabInterface'

const PrescriptionDashboard = () => {
  const params = useParams()
  const prescription = useSelector<ReducerType, PrescriptionViewModel>(
    (state) => state.reducerPrescription
  )
  const patient = prescription.patient
  const [deserveModal, setDeserveModal] = useState<DeserveModalInterface>({
    isOpen: false,
    data: {
      firstName: patient?.firstName,
      lastName: patient?.lastName,
      age: patient?.age,
      gender: patient?.gender,
      code: patient?.code,
      insuranceTypeTitle: patient?.insuranceTypeTitle,
      mobile: patient?.mobile,
      imageUrl: patient?.imageUrl,
      insuranceExpirationDate: patient?.insuranceExpirationDate
        ? new Date(patient?.insuranceExpirationDate).toShamsi()
        : '',
      insuranceBoxTitle: patient?.insuranceBoxTitle,
    },
    showFooter: false,
    hideModal() {
      setDeserveModal({ ...deserveModal, isOpen: false })
    },
  })
  const user = useSelector<ReducerType, LoginInterface>(
    (state) => state.reducerUser
  )
  const center = useSelector<ReducerType, CenterViewModel>(
    (state) => state.reducerCenter
  )
  const { isLoading, reFetch } = useFetch<DeserveDataModalInterface, Object>({
    request: RaytebRequests.Appointment_Deserve_POST({
      headers: { centerId: center.id },
      token: user?.token,
    }),
    onSuccess(data) {
      setDeserveModal({
        ...deserveModal,
        data: data,
        isOpen: true,
        showFooter: false,
      })
      data.messages?.forEach((n) => {
        if (n.flag === ErrorTypeEnum.Error) toast.error(n.message)
        else if (n.flag === ErrorTypeEnum.Info) toast.info(n.message)
        else if (n.flag === ErrorTypeEnum.Warning) toast.warn(n.message)
        else toast.info(n.message)
      })
    },
  })

  var listTab: Array<TabInterface> = [
    {
      title: 'پرونده',
      icon: 'rayteb-record',
      className: {
        iconClass: 'text-3xl ',
        className: 'px-10 pb-1',
        titleClass: 'text-xs',
      },
      index: params.componenet === 'record',
      element: (
        <Record
          patientCode={prescription.patient?.code!}
          ticketId={prescription.ticketId!}
        />
      ),
    },
    {
      title: 'نسخه نویسی',
      icon: 'rayteb-prescription',
      className: {
        iconClass: 'text-3xl ',
        className: 'px-10 pb-1',
        titleClass: 'text-xs',
      },
      index: params.componenet === 'newPrescription',
      element: <Prescription {...prescription} />,
    },
  ]
  if (!(center.hasPrescription || center.hasRecord)) {
    listTab = []
  }
  else if (!center.hasPrescription)
    listTab = listTab.filter(x => x.title !== "نسخه نویسی")
  else if (!center.hasRecord)
    listTab = listTab.filter(x => x.title !== "پرونده")

  useEffect(() => {
    setDeserveModal({ ...deserveModal, data: patient })
  }, [patient])
  return (
    <>
      <div className={classes.header}>
        <LoadingFit isLoading={isLoading} />

        <div className={classes['image-profile']}>
          <Avatar
            className='!w-12 !h-12 md:!w-20 md:!h-20'
            url={patient?.imageUrl}
          />
        </div>
        <div className={classes['user-info']}>
          <h3 className={classes['user-name']}>
            {`${patient?.firstName} ${patient?.lastName}`}
          </h3>
          <p className='text-[#b6c0c9] text-xs'>
            {patient?.age ? (
              <span>{patient?.age}</span>
            ) : (
              ''
            )}
            {'   '}
            {patient?.gender ? (
              <>
                <span>{GenderEnum[patient?.gender!]}</span>
              </>
            ) : (
              ''
            )}
            <span>&nbsp;&nbsp;&nbsp;</span>
            <span className='text-white '>
              {patient?.insuranceBoxTitle}
            </span>
          </p>
          <p className={classes['insurance']}>
            <span>{patient?.insuranceTypeTitle}</span>
            {'   '}
            <span>{patient?.insuranceExpirationDate ? new Date(patient?.insuranceExpirationDate).toShamsi() : ''}</span>
          </p>
        </div>
        <div className={classes['user-action']}>
          <Button
            className='!py-2 !h-7  !text-primary !border-none w-24 !bg-white'
            onClick={() => {
              reFetch({ patientCode: patient?.code, mobile: patient?.mobile })
            }}
          >
            استحقاق
          </Button>
          <span className='text-[11px] text-white mt-2'>
            {prescription.trackingCode
              ? `کد رهگیری : ${prescription.trackingCode.shortText(5)}`
              : ''}
          </span>
          <Button
            onClick={() => setDeserveModal({ ...deserveModal, isOpen: true })}
            className={`${classes['edit-action']} `}
          >
            مشاهده / ویرایش
          </Button>
        </div>
      </div>
      <TabGroup items={listTab} />

      <DeserveModal {...deserveModal} />
    </>
  )
}

export default PrescriptionDashboard

PrescriptionDashboard.GoToPage = ({ children }): ReactElement => {
  return <></>
}

PrescriptionDashboard.Layout = ({ children }): ReactElement => {
  return (
    <>
      <SecondaryLayout title={'تجویز کنید'}>{children}</SecondaryLayout>
    </>
  )
}
